import script from "./MenuPageHorizontal.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuPageHorizontal.vue?vue&type=script&setup=true&lang=js"

import "./MenuPageHorizontal.vue?vue&type=style&index=0&id=2ba7085e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ba7085e"]])

export default __exports__